import {Box, Image, Skeleton} from '@chakra-ui/react';
import * as React from 'react';

const ImageView = (props) => {
    const {url, src, alt, objectPosition = 'cover', draggable, ...rest} = props;

    return (
        <Box overflow="hidden" position="relative" width="full" {...rest}>
            <Image
                boxSize="full"
                maxHeight={{md: '100%'}}
                src={src}
                alt={alt}
                objectFit="cover"
                objectPosition={objectPosition}
                fallback={<Skeleton/>}
                draggable={draggable}
            />
        </Box>
    );
};
export default ImageView;
